import React from 'react';
import { Stack, Text } from '@moda/om';
import ReturnsIcon from '@moda/icons/returns-16';
import { BehindFeatureFlag } from '@moda/portal-stanchions';
import { OrderItemReturnPolicy } from '../../constants';

interface Props {
  returnPolicyCode: OrderItemReturnPolicy;
  promoCodeApplied: boolean;
}

export const LineItemReturnPolicyHeader: React.FC<Props> = ({ promoCodeApplied }) => (
  <Stack className="LineItemReturnPolicyHeader" direction="horizontal" space={2}>
    <ReturnsIcon />
    <Text treatment="body1">
      {' '}
      <BehindFeatureFlag
        flagName="link_promo_with_returns"
        showWhenValueIs={true}
        showIfFlagIsUnavailable
      >
        {promoCodeApplied ? 'Updated' : ''}
      </BehindFeatureFlag>{' '}
      Return Policy{' '}
    </Text>
  </Stack>
);
